import {enforce} from "vest";

export function timeSlotSize(value: any) {
  enforce(value).message('validator.time_slot_size').isBetween(15, 120);
}
